import { api } from '.';
import { pathOr } from 'rambda';
import { left, right } from 'fp-ts/lib/Either';
import { flow } from 'fp-ts/function';
import { ErrorCode, IError } from '..';

export const qa = () =>
  api(`${process.env.REACT_APP_API_QA_URL}`)
    .get(`v1/api/q-and-a/csos`)
    .then(flow(pathOr([], 'data'), right))
    .catch(e =>
      left({ code: ErrorCode.ApiError, message: e.message } as IError)
    );
